import { useAuthStore } from '@/features/auth/useAuthStore.js'

export async function sessionGuard(to, from, next) {
  // Skip guard for error page to prevent infinite loops
  const isOnErrorPage = to?.name === 'error' || to?.path?.includes('/error')

  if (isOnErrorPage) {
    next()
    return
  }

  const authStore = useAuthStore()
  try {
    console.log('[sessionGuard] Starting getMyDetails')
    await authStore.getMyDetails()
    console.log('[sessionGuard] getMyDetails completed successfully')
  } catch (e) {
    console.error('[sessionGuard] getMyDetails failed:', {
      error: e,
      message: e?.message,
      response: e?.response,
      status: e?.response?.status,
      data: e?.response?.data,
      code: e?.code,
      stack: e?.stack,
    })
    // Eğer sessionGuard'da hata olursa, bu hata yakalanmıyor ve useAuthStore'daki catch'e düşüyor
    throw e
  }

  next()
}
